function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 5");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Homepage",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-/-Homepage_GIANT",
  transform: "translate(-1663.000000, -2160.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(1663.000000, 2160.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100.390713,4.73283867 C110.275713,11.7858387 111.940713,27.9228387 112.348713,42.3918387 C112.723713,56.8908387 111.838713,69.7488387 105.520713,80.1138387 C99.2357128,90.4458387 87.5837128,98.3508387 75.1157128,100.993839 C62.6447128,103.669839 49.3637128,101.083839 37.8107128,96.4038387 C26.2937128,91.6938387 16.5437128,84.8538387 9.54471281,75.7368387 C2.58171281,66.6468387 -1.59728719,55.2798387 0.577712808,45.0378387 C2.78571281,34.7928387 11.3447128,25.7058387 21.3677128,18.6828387 C31.4237128,11.6328387 42.9077128,6.67683867 57.6857128,3.18183867 C72.4637128,-0.313161327 90.5387128,-2.32016133 100.390713,4.73283867",
  id: "Fill-6",
  fill: "#EC614D"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icons/arrow",
  transform: "translate(56.000000, 51.000000) scale(-1, 1) translate(-56.000000, -51.000000) translate(16.000000, 11.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "baseline-keyboard_backspace-24px"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 80 0 80 80 0 80"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  points: "70 36.6666667 22.7666667 36.6666667 34.7 24.7 30 20 10 40 30 60 34.7 55.3 22.7666667 43.3333333 70 43.3333333"
})))))));

var SvgNextslide = function SvgNextslide(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "113px",
    height: "103px",
    viewBox: "0 0 113 103",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNextslide, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nextslide.43c7d9a5.svg";
export { ForwardRef as ReactComponent };